import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../utilities/timeUtility';
import Translation from '../../utilities/localizationUtility';
import { getUpcomingEventsProducts } from '../../services/api';
import Alert from '../../components/Alert';
import ExceededMessage from '../../components/ExceededMessage';
import TimeZone from '../../components/Common/TimeZone';
import { stringToBoolean } from '../../utilities/conversionUtility';
import { interpolatePriceToTemplate, priceFormat } from '../../utilities/helperUtility';
import BrandingString from '../components/BrandingString';

const filtratedProducts = (products, filterTags) => {
  let tags = [];
  if (filterTags) {
    tags = Object.values(filterTags).filter((x) => !stringToBoolean(x._destroy));
  }
  if (tags.length === 0) return products;

  const temp = tags.map((x) => parseInt(x.filter_tags));
  return products.slice(0).filter((x) => x.tags.some((y) => temp.includes(y)));
};

const Loader = () => (
  <div className="text-center clear-both">
    <h4 className="noEvent no-break m0">Loading...</h4>
  </div>
);

export default class UpcomingEventPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      loading: false,
    };
    this.loadProducts = this.loadProducts.bind(this);
  }

  componentDidMount() {
    this.loadProducts();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      xPropMode,
      setting: { filter_tags: filterTags, show_booked_out_events: showBookedOutEvents, show_repeat_occurrences: showRepeatOccurrences },
    } = this.props;

    const { setting: { show_booked_out_events: prevShowBookedOutEvents, show_repeat_occurrences: prevShowRepeatOccurrences } } = prevProps;

    const modifyWidthCallback = () => {
      const { products } = this.state;

      if (xPropMode === 'popup' && filtratedProducts(products, filterTags).length > 0) {
        this.modifyWidth();
      }
    }

    if (showBookedOutEvents !== prevShowBookedOutEvents || showRepeatOccurrences !== prevShowRepeatOccurrences) {
      this.loadProducts().then(() => modifyWidthCallback());
    } else {
      modifyWidthCallback()
    }
  }

  containerDetails() {
    const { style: { body = {}, container = {} }, setting } = this.props;
    return {
      styles: `
        .bta-upcoming-event-widget-container {
          background-color: ${setting.events_background_color || body.background} !important;
          border-radius: ${container.widgetContainerBorderRadius}px !important;
          
          iframe {
            border-radius: ${container.widgetContainerBorderRadius}px !important;
          }
        }
      `,
    };
  }

  bookedOutTextStyle() {
    const { setting: { mode, booked_out_text_color } } = this.props;

    if (mode === 'inline-block') {
      return {
        color: booked_out_text_color || '#ff4444',
        fontWeight: 'bold',
        fontSize: 'calc(75%)',
        letterSpacing: '1px',
      };
    } else {
      return {
        color: booked_out_text_color || '#ff4444',
        fontWeight: 'bold',
        fontSize: 'calc(75%)',
        letterSpacing: '1px',
        marginTop: '1px'
      };
    }
  }

  modifyWidth() {
    const list = this.menuList;
    const products = this.products();
    const { onTrigger } = this.props;

    if (list) {
      const menuListWidth = Array.from(list.querySelectorAll('h4')).map((x) => x.clientWidth);

      let maxWidth = Math.max(...menuListWidth) + 120;
      if (maxWidth < 260 || !products.length) maxWidth = 260;

      onTrigger && onTrigger('resize', `${maxWidth}px`);

      if (window.xprops && window.xprops.onSize) window.xprops.onSize(maxWidth);

      // xcomponent has resize problem, a trick to fire resize
      list.classList.remove('dib');
      list.classList.add('db');
    }
  }

  async loadProducts() {
    const { exceededBookingsLimit, exceededTrialPlan, setting } = this.props;
    try {
      if (!exceededTrialPlan && !exceededBookingsLimit) {
        this.setState({ loading: true });

        const showBookedOut = setting.show_booked_out_events || false;
        const showRepeatOccurrences = setting.show_repeat_occurrences || false;
        const products = await getUpcomingEventsProducts({ showBookedOut, showRepeatOccurrences });
        const color = this.props.settings.setting.widget_background_color;
        if (color !== 'transparent') {
          const icon = parent.document.querySelector("[id*=upcoming-event-icon]");
          if (icon) {
            icon.style.background = color;
            icon.style.display = 'block';
            icon.style.visibility = 'visible';
          }
        }
        this.setState({ loading: false, products });

        this.modifyWidth();

        return true;
      }
      return true;
    } catch (e) {
      this.setState({ loading: false });
      console.log(e);
    }
  }

  products() {
    const {
      setting: { number_of_events: numberOfEvent, filter_tags: filterTags },
      defaultSetting,
    } = this.props;
    const { products } = this.state;
    const eventsCount = numberOfEvent || (defaultSetting.setting && defaultSetting.setting.number_of_events) || 12;

    return filtratedProducts(products, filterTags).slice(0, eventsCount);
  }

  timeZone() {
    return this.props.timeZone;
  }

  render() {
    const {
      setting,
      settings,
      xPropMode,
      onTrigger,
      style,
      exceededBookingsLimit,
      exceededTrialPlan,
      messages,
      brandingVisualized,
    } = this.props;
    const { events_per_row: eventsPerRow } = setting;
    const windowWidth = window.innerWidth
    const exceeded = exceededBookingsLimit || exceededTrialPlan;
    const { loading } = this.state;
    const products = this.products();
    const popMode = xPropMode === 'popup' || setting.mode === 'popup';
    const inlineBlockMode = setting.mode === 'inline-block' && xPropMode !== 'popup';
    const t = new Translation(this.props);
    const title = t.key('title')?.trim();
    const widgetBackgroundColor = setting.widget_background_color === 'transparent'
      ? undefined
      : setting.widget_background_color;

    const containerBodyStyle = {
      ...style.body,
      backgroundColor: setting.events_background_color || style.body.backgroundColor,
      borderRadius: `${style.container?.widgetContainerBorderRadius}px !important`,
    };

    if (onTrigger) { onTrigger('onWidgetStyleChange', this.containerDetails()); }

    return (
      <div className="upcoming-events-container center" style={{...containerBodyStyle, ...style.boxShadow}}>
        {popMode && !!title && (
          <div
            name="title"
            className="text-center ptb15 gradient white"
            style={{
              ...style.title,
              ...{
                background: widgetBackgroundColor,
              },
            }}
          >
            <p className="m0" style={{textTransform: 'uppercase'}}>{title}</p>
          </div>
        )}

        { exceeded ? (
          <Alert
            unclosed={true}
            messages={[<ExceededMessage message={messages.message_booking_limit_reached} />]}
            type="exceeded-trial-plan-ue"
            disableIcon={true}
          />
        ) :
          inlineBlockMode ? (
            <div style={{ 
              padding: '8px',
              display: 'grid',
              gridTemplateColumns: windowWidth < 500 ? '1fr' : `repeat(${eventsPerRow || 5}, 1fr)`,
              gap: '8px',
              width: '100%'
            }}>
              {products.map((product, index) => (
                <div
                  key={`${product.external_id}-${product.occurrence}-${index}`}
                  className="pointer"
                  onClick={() => product.shopify_url && onTrigger && onTrigger('replace', product.shopify_url)}
                  role="presentation"
                >
                  <div className="center text-center p15">
                      {product.image_url && (
                        <div
                          className="center background-image"
                          style={{ backgroundImage: `url('${product.image_url}')` }}
                        />
                      )}
                      <p className="m0 mt10 letter-spacing">{product.title}</p>
                      {product.occurrence && (
                        <p className="no-break m0 mt15 letter-spacing" style={{ fontSize: 'calc(75%)' }}>{formatDate(product.occurrence, this.timeZone())}</p>
                      )}
                      {product.price && (
                        <p className="no-break m0 mt5 letter-spacing" dangerouslySetInnerHTML={{ __html: interpolatePriceToTemplate(priceFormat(settings), product.price) }} />
                      )}
                      {product.booked_out && (
                        <p className="m0 mt5" style={this.bookedOutTextStyle()}>
                          {t.key('bookedOut') || 'Booked Out'}
                        </p>
                      )}
                    </div>
                  </div>
              ))}
            </div>
          ) : (
            <ul ref={(x) => (this.menuList = x)} style={{ padding: '10px 25px 15px' }} className="pure-menu-list center">
              {products.length ? (
                products.map((product, index) => (
                  <li className="pure-menu-item" key={`${product.external_id}-${product.occurrence}-${index}`}>
                    <div
                      ref={(x) => (this.menuList = x)}
                      className={`pointer flexbox space-between clear-both ${product.booked_out ? 'booked-out-event' : ''}`}
                      onClick={() => onTrigger && onTrigger('replace', product.shopify_url)}
                      role="presentation"
                    >
                      <div className="title-block">
                        <h4 className="no-break productTitle m0">{product.title}</h4>
                        <p className="m0" style={{ marginTop: '1px', paddingRight: '10px', fontSize: 'calc(75%)' }}>
                          {formatDate(product.occurrence, this.timeZone())}
                        </p>
                        {product.booked_out && (
                          <p className="m0 booked-out-list-text" style={this.bookedOutTextStyle()}>
                            {t.key('bookedOut') || 'Booked Out'}
                          </p>
                        )}
                      </div>
                      {product.image_url && (
                        <div style={{ paddingLeft: '40px' }}>
                          <div
                            className="center background-image"
                            style={{
                              backgroundImage: `url('${product.image_url}')`,
                              width: '40px',
                              marginTop: '1px',
                              borderRadius: '5px',
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </li>
                ))
              ) : (
                <li className="pure-menu-item">
                  <div ref={(x) => (this.menuList = x)} className="text-center clear-both">
                    <h4 className="noEvent no-break m0">{t.key('noEvent')}</h4>
                  </div>
                </li>
              )}
            </ul>
          )}

        {loading && <Loader />}

          <div style={{ padding: '0px 25px 15px' }}>
            {stringToBoolean(setting.show_timezone_chooser) && (
              <TimeZone timeZone={this.timeZone()} />
            )}
            {brandingVisualized && <BrandingString />}
          </div>
      </div>
    );
  }
}

UpcomingEventPage.propTypes = {
  timeZone: PropTypes.string,
  xPropMode: PropTypes.string,
  translation: PropTypes.object,
  defaultTranslation: PropTypes.object,
  setting: PropTypes.shape({
    number_of_events: PropTypes.string,
    filter_tags: PropTypes.arrayOf(PropTypes.object),
  }),
  defaultSetting: PropTypes.object,
  products: PropTypes.arrayOf(PropTypes.object),
  onTrigger: PropTypes.any,
};
